module.exports = __webpack_public_path__ + "02_glasses_red.19bc23cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/02_glasses_red.png
// module id = ESRn
// module chunks = 0